import { Money } from "models/money";

export function getExcelData(data) {
  // param: data list of: [    {
  //     "empresa": "ALIMENTOS BALANCEADOS AVIFORTE CIA. LTDA.",
  //     "venta1": 26339344.90,
  //     "venta2": 27030684.20,
  //     "venta3": 26711677.80,
  //     "totalsales": 80081706.90,
  //     "sector": "AVICULTURA / GANADERÍA"
  // }]
  let rows = [];
  data.forEach((elem, index) => {
    var _known = {
      Numero: index + 1,
      Empresa: elem.empresa,
      Sector: elem.sector,
      Total: Money(elem.totalsales),
      "Año 2019": Money(elem.venta1),
      "Año 2020": Money(elem.venta2),
      "Año 2021": Money(elem.venta3),
    };
    rows.push(_known);
  });
  return rows;
}
